import { render, staticRenderFns } from "./FitnessplanChallengeSummary.vue?vue&type=template&id=3f576a6a&scoped=true"
import script from "./FitnessplanChallengeSummary.vue?vue&type=script&lang=js"
export * from "./FitnessplanChallengeSummary.vue?vue&type=script&lang=js"
import style0 from "./FitnessplanChallengeSummary.vue?vue&type=style&index=0&id=3f576a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f576a6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
